

// Utility: wait for a condition with retries
const waitFor = (checkFn, { interval = 50, timeout = 8000 } = {}) =>
  new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      try {
        const ok = checkFn();
        if (ok) return resolve(ok);
        if (Date.now() - start > timeout) return reject(new Error('waitFor timeout'));
        setTimeout(tick, interval);
      } catch (e) {
        reject(e);
      }
    };
    tick();
  });

document.addEventListener('DOMContentLoaded', async () => {
  try {
    // 1. Wait until Clerk is available
    await waitFor(() => typeof window.Clerk === 'function');
    // 2. Wait until sliders exist in DOM
    await waitFor(() => document.querySelector('.clerk-swiper-wrapper'));

    const clerk_wrappers = document.querySelectorAll('.clerk-swiper-wrapper');

    clerk_wrappers.forEach((clerk_wrapper) => {
      const endpoint = clerk_wrapper.dataset.endpoint;
      const category = clerk_wrapper.dataset.category
        ? parseInt(clerk_wrapper.dataset.category)
        : undefined;
      const limit = parseInt(clerk_wrapper.dataset.limit);
      const label = clerk_wrapper.dataset.labels;

      let productsParam;

      // Handle product page
      if (window.location.pathname.includes('/products/')) {
        const pid = parseInt(clerk_wrapper.dataset.product);
        productsParam = Number.isFinite(pid) ? [pid] : undefined;
      }

      // Handle cart page
      else if (window.location.pathname.includes('/cart')) {
        try {
          const productsArray = JSON.parse(clerk_wrapper.dataset.products)
            .map(Number)
            .filter(Number.isFinite);
          productsParam = productsArray.length ? productsArray : undefined;
        } catch {
          productsParam = undefined;
        }
      }

      const fetchResponse = async () => {
        const response = await window.Clerk('call', endpoint, {
          attributes: ['id', 'handle'],
          limit,
          products: productsParam,
          labels: [label],
          category,
        });

        if (!response || response.status !== 'ok') {
          throw new Error(`Clerk call failed for ${endpoint}`);
        }
        if (!Array.isArray(response.product_data) || response.product_data.length === 0) {
          throw new Error('No product_data returned from Clerk');
        }
        return response;
      };

      const fetchProduct = async ({ handle, id }) => {
        const result = await fetch(`/products/${handle}?view=view`);
        const html = await result.text();
        const node = document.createElement('div');
        node.innerHTML = html;
        const productHtml = node.firstElementChild;

        // Add data-clerk-product-id attributes
        productHtml.querySelectorAll('a').forEach((a) =>
          a.setAttribute('data-clerk-product-id', id)
        );
        productHtml.querySelectorAll('button').forEach((b) =>
          b.setAttribute('data-clerk-product-id', id)
        );

        return productHtml.outerHTML;
      };

      const getProducts = async (products) => Promise.all(products.map(fetchProduct));

      const initClerk = async () => {
        try {
          const { product_data: products } = await fetchResponse();

          const productsHTML = await getProducts(products);
          clerk_wrapper.innerHTML = '';
          productsHTML.forEach((html) => {
            clerk_wrapper.insertAdjacentHTML('beforeend', html);
          });

          // Register click tracking
          window.Clerk('click', '*[data-clerk-product-id]');

          // Update swiper if it exists
          if (window.clerk_swiper && typeof window.clerk_swiper.update === 'function') {
            window.clerk_swiper.update();
          }
        } catch (err) {
          console.error('[Clerk slider]', err);
        }
      };

      initClerk();
    });
  } catch (e) {
    console.error('[Clerk boot]', e);
  }
});
